import React, { useEffect, useRef, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Slider from 'react-slick'
import s from './principalSlider.module.css'
import { GTMEvents } from '../../../lib/GTMevents'
import { SomosCredicorp } from '../../../svg/somos_credicorp'
import Btn from '../../buttons/buttons'
import Img from 'gatsby-image'
import { BASE_URL_TRASPASO } from '../../../constants/URLs'

const PrincipalSlider = () => {
  const imageData = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { in: [
            "ico-play.png",
            "ico-pause.png",
            "banner/banner-web-eloy.png",
            "banner/banner-web-reforma-pensiones.png",
            "banner/banner-retiro-abril.jpg",
            "banner/pensionistas-web.png",
            "banner/adaptacion_banner_cohete.webp",
            "banner/ahorrando-a-fondo.png",
            "banner/Banner-beneficios-web.png",
            "banner/banner-tramites-2024.png",
          ] }
        }
      ) {
        nodes {
          name
          relativePath
          childImageSharp {
            fluid(quality: 75) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  const sliderSecondRef = useRef()
  const sliderMainRef = useRef()

  const sliderInView = useRef(true)
  const slideSeen = useRef([])

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0]

      sliderInView.current = entry.isIntersecting
    })
    observer.observe(sliderSecondRef.current)
  }, [])

  /* DATA SLIDER PRINCIPAL */
  const heroData = [
    {
      title: 'Lo más importante del futuro es el hoy',
      titleColor: '',
      description: '',
      descriptionColor: '',
      buttonLabel: 'Conoce a Eloy',
      link: 'https://www.prima.com.pe/public-zone/por-que-elegir-prima/',
      image: 'banner/banner-web-eloy.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF7D9',
    },
    {
      title: 'Prima te acompaña con 19 años de trayectoria con una sólida rentabilidad',
      titleColor: '',
      description: '',
      descriptionColor: '',
      buttonLabel: '¡Cámbiate ahora!',
      link:
        `${BASE_URL_TRASPASO}/pasos0`,
      image: 'banner/adaptacion_banner_cohete.webp',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF',
    },
    {
      title: '¿Conoces cuáles son los principales cambios en la reforma del sistema previsional?',
      titleColor: '',
      description: '',
      descriptionColor: '',
      buttonLabel: 'Conoce más aquí',
      link: 'https://www.prima.com.pe/public-zone/reforma',
      image: 'banner/banner-web-reforma-pensiones.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF',
    },
    {
      title: '¿Recibes tu pensión en ventanilla?',
      titleColor: '',
      description:(
      <>
      Cambia la forma de pago de tu pensión a abono en cuenta.
      <br /><br />
      Llámanos al 615-7272 opción 9.
      </>
      ),
      descriptionColor: '',
      buttonLabel: '',
      link: '',
      image: 'banner/pensionistas-web.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF',
    },
    {
      title: 'Aprende todo sobre las AFP, finanzas personales y más.',
      titleColor: '',
      description: '',
      descriptionColor: '',
      buttonLabel: 'Descubre Ahorrando a Fondo',
      link: 'https://www.ahorrandoafondo.com/',
      image: 'banner/ahorrando-a-fondo.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF7D9',
    },
    {
      title: '¡Conoce Beneficios Prima!',
      titleColor: '',
      description: 'Nuestra renovada plataforma de beneficios',
      descriptionColor: '',
      buttonLabel: 'Conócelo aquí',
      link: 'https://www.beneficiosprima.pe/BeneficiosPrimaWeb/home',
      image: 'banner/Banner-beneficios-web.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FFF',
    },
    {
      title: 'Realiza tus trámites desde nuestra Agencia Virtual',
      titleColor: '',
      description: '',
      descriptionColor: '',
      buttonLabel: 'Ingresa aquí',
      link:
        'https://miespacio.prima.com.pe/?utm_campaign=TR&utm_medium=Web&utm_source=banner_web&utm_content=Tramites_Remotos&utm_term=TR&utm_id=banner_web',
      image: 'banner/banner-tramites-2024.png',
      imageSomos: <SomosCredicorp fill={'#000'} />,
      infoAditional: '',
      infoAditionalColor: '',
      bgColor: '#FBF5F9',
    },
  ]

  const [sliderAutoPlay, setSliderAutoPlay] = useState({
    btnPlay: false,
    btnPause: true,
  })

  const slickSettingsMain = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: 'div',
    autoplay: true,
    autoplaySpeed: 8000,
    pauseOnHover: false,
    adaptiveHeight: true,
    infinite: true,
    dotsClass: `slick-dots ${s.sliderMainPaginator} slick-dots__custom`,
    appendDots: dots => (
      <div>
        <div className="containerWrap" ref={sliderSecondRef}>
          <div className="flex items-center">
            {sliderAutoPlay.btnPlay && (
              <button
                className={`${s.btnPlay} tw-ml-2 tw-mr-2`}
                onClick={() => {
                  sliderMainRef.current.slickPlay()
                  setSliderAutoPlay({ btnPlay: false, btnPause: true })
                }}
              >
                <Img
                  fluid={
                    imageData.allFile.nodes.find(
                      node => node.name === 'ico-play'
                    ).childImageSharp.fluid
                  }
                  alt="play"
                  loading="lazy"
                  className={`${s.btnPlay} db`}
                  // imgStyle={{objectFit: 'contain'}}
                />
              </button>
            )}
            {sliderAutoPlay.btnPause && (
              <button
                className={`${s.btnPlay} tw-ml-2 tw-mr-2`}
                onClick={() => {
                  sliderMainRef.current.slickPause()
                  setSliderAutoPlay({ btnPlay: true, btnPause: false })
                }}
              >
                <Img
                  fluid={
                    imageData.allFile.nodes.find(
                      node => node.name === 'ico-pause'
                    ).childImageSharp.fluid
                  }
                  alt="pause"
                  loading="lazy"
                  className={`${s.btnPlay} db`}
                  // imgStyle={{objectFit: 'contain'}}
                />
              </button>
            )}
            <ul style={{ margin: '0' }}>{dots}</ul>
          </div>
        </div>
      </div>
    ),
    customPaging: i => <span className={`ft-slick__dots--custom`}></span>,
    beforeChange: (oldIndex, newIndex) => {
      if (
        sliderInView.current &&
        slideSeen.current.includes(oldIndex) === false
      ) {
        GTMEvents.MainSlierView(heroData[oldIndex].title, oldIndex + 1)
        let prevSlides = [...slideSeen.current]
        slideSeen.current = [...prevSlides, oldIndex]
      }
    },
  }
  /* FIN DATA SLIDER PRINCIPAL */

  return (
    <Slider ref={sliderMainRef} {...slickSettingsMain}>
      {heroData.map((item, index) => {
        const imageNode = imageData.allFile.nodes.find(
          node => node.relativePath === item.image
        )

        return (
          <div key={item.title}>
            <div
              className={`${s.sliderMain}`}
              style={{ backgroundColor: item.bgColor }}
            >
              <div className={`containerWrap`}>
                <div
                  className={`flex direction-column direction-row@lg justify-between justify-around@lg`}
                >
                  <div
                    className={`flex direction-column justify-between items-start w-100 w-45@lg tw-mb-8 tw-mb-0@lg tw-px-2 tw-pl-0@lg tw-pr-20@lg `}
                  >
                    <div className={`tw-pt-8@lg tw-pl-2@lg`}>
                      {item.imageSomos && (
                        <div className={`tw-mb-6 left`}>{item.imageSomos}</div>
                      )}

                      {item.title && (
                        <h2
                          className={`font-family-secondary fw-7 tw-f-18 tw-f-36@lg tw-mb-6 left`}
                          style={{ color: item.titleColor }}
                        >
                          {item.title}
                        </h2>
                      )}

                      {item.description && (
                        <div
                          className={`font-family-primary fw-0 tw-f-16 tw-f-18@lg tw-mb-6 left`}
                          style={{ color: item.descriptionColor }}
                        >
                          {item.description}
                        </div>
                      )}

                      {item.buttonLabel && (
                        <div
                          onClick={() =>
                            GTMEvents.BtnHomeSliderHero(
                              item.title,
                              item.buttonLabel,
                              index + 1
                            )
                          }
                        >
                          <Btn
                            id="GTM-MOD-MEP-BTN-MAIN-SIDEBAR-HERO"
                            type="link"
                            href={item.link}
                            label={item.buttonLabel}
                            color="orange"
                            size="medium"
                            className={`font-family-secondary fw-6 tw-f-18 tw-f-16@lg w-100 w-auto@lg tw-py-4 tw-px-4 tw-px-8@lg tw-py-2@lg ${item.buttonLabel === 'Traspásate aquí' ? "improve-analytics-btn-slider" : ""}`}
                          />
                        </div>
                      )}
                    </div>

                    {item.infoAditional && (
                      <div
                        className={`font-family-primary fw-0 tw-f-14 tw-pb-14 tw-pl-2 dn db@lg`}
                        style={{ color: item.infoAditionalColor }}
                      >
                        {item.infoAditional}
                      </div>
                    )}
                  </div>
                  <div
                    className={`${s.itemCarouselMain_imageWrap} justify-center items-center justify-end@lg items-center w-100 w-55@lg`}
                  >
                    {imageNode ? (
                      <Img
                        key={item.image}
                        fluid={imageNode.childImageSharp.fluid}
                        alt={item.image}
                        loading={'lazy'}
                        className={s.itemCarouselMain_image}
                        imgStyle={{ objectFit: 'contain' }}
                      />
                    ) : (
                      <p key={item.image}>
                        Error: No se encontró "{item.image.slice(7)}"
                      </p>
                    )}
                  </div>

                  {item.infoAditional && (
                    <div
                      className={`font-family-primary fw-0 tw-f-14 tw-pb-8 tw-mt-4 db dn@lg`}
                      style={{ color: item.infoAditionalColor }}
                    >
                      {item.infoAditional}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </Slider>
  )
}

export default PrincipalSlider
